'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IndexedDbManager = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndexedDbManager = exports.IndexedDbManager = undefined;

exports.IndexedDbManager = IndexedDbManager = function IndexedDbManager() {
    var t = this;

    // constants
    var _db = 'dhis2';
    var _objectStores = ['optionSets'];

    _extends(t, new dhis2.storage.Store({
        name: _db,
        objectStores: _objectStores,
        adapters: [dhis2.storage.IndexedDBAdapter, dhis2.storage.DomSessionStorageAdapter, dhis2.storage.InMemoryAdapter]
    }));

    // cache
    t.cachedOptionSets = {};
};

IndexedDbManager.prototype.getCachedOptionSet = function (id) {
    return this.cachedOptionSets[id];
};

IndexedDbManager.prototype.setCachedOptionSet = function (optionSet) {
    this.cachedOptionSets[optionSet.id] = optionSet;
};

IndexedDbManager.prototype.hasCachedOptionSet = function (id) {
    return id in this.cachedOptionSets;
};

// dep 1

IndexedDbManager.prototype.getOptionSets = function (ids, callbackFn) {
    ids = (0, _arrayFrom2.default)(ids);

    var t = this;
    var callbacks = 0;
    var requestIds = [];
    var optionSets = [];

    var fn = function fn() {
        if (!requestIds.length || requestIds.length === ++callbacks) {
            callbackFn(optionSets);
        }
    };

    // cached option sets
    ids.forEach(function (id) {
        var cachedOptionSet = t.getCachedOptionSet(id);

        if (cachedOptionSet) {
            optionSets.push(cachedOptionSet);
        } else {
            requestIds.push(id);
        }
    });

    // requested option sets
    if (requestIds.length) {
        requestIds.forEach(function (id) {
            t.get('optionSets', id).done(function (requestedOptionSet) {
                t.setCachedOptionSet(requestedOptionSet);
                optionSets.push(requestedOptionSet);

                fn();
            });
        });
    } else {
        fn();
    }
};

// dep 2

IndexedDbManager.prototype.getCachedOption = function (code, optionSetId) {
    var cachedOptionSet = this.getCachedOptionSet(optionSetId);

    if (!cachedOptionSet) {
        console.log('WARNING: Option set with id "' + optionSetId + '" not found');
        return;
    }

    if (!cachedOptionSet.options) {
        console.log('WARNING: Option set with id "' + optionSetId + '" has no options');
        return;
    }

    return cachedOptionSet.options.find(function (option) {
        return option.code === code;
    });
};

// dep 3

IndexedDbManager.prototype.getCachedOptionName = function (code, optionSetId) {
    var cachedOption = this.getCachedOption(code, optionSetId);

    if (!cachedOption) {
        console.log('WARNING: Option set with id "' + optionSetId + '" has no option with code "' + code + '"');
        return code;
    }

    return cachedOption.name;
};
//# sourceMappingURL=IndexedDbManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/manager/IndexedDbManager.js
 ** module id = 188
 ** module chunks = 0 1
 **/